import React, { useState } from 'react';
import Tooltip from '@app/react-common/components/tooltip/Tooltip';

const COPY_TOOLTIP = "Copy, then paste into the checkout's Address line 2 to preview this variant";
const COPIED_TOOLTIP = 'Copied! Paste it into Address line 2 at checkout';

interface VariantPreviewCopyButtonProps {
  previewString: string;
}

export function VariantPreviewCopyButton({ previewString }: VariantPreviewCopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(previewString);
    setCopied(true);
  };

  return (
    <Tooltip tooltipText={copied ? COPIED_TOOLTIP : COPY_TOOLTIP} maxWidth={240}>
      <button
        type="button"
        className="variant-preview-copy"
        aria-label="Copy variant preview token"
        data-attr="ab-test-copy-variant-preview"
        onClick={handleCopy}
        onMouseLeave={() => setCopied(false)}>
        <span className={`variant-preview-copy__icon variant-preview-copy__icon--${copied ? 'check' : 'copy'}`} />
      </button>
    </Tooltip>
  );
}
